import { createContext, useContext } from 'react'
import type { ToolCall } from '../../../../types'

// ---------------------------------------------------------------------------
// Context — lets ToolCallRenderer read the full set without a prop. The map's
// entries are the store's own ToolCall objects (reference-stable per
// `sink-patches.ts`), so the value only changes identity when a call does.
// ---------------------------------------------------------------------------

const ToolCallsContext = createContext<Map<string, ToolCall>>(new Map())

export const ToolCallsProvider = ToolCallsContext.Provider

export function useToolCallsMap(): Map<string, ToolCall> {
  return useContext(ToolCallsContext)
}
